"use client";

import { Riple } from "react-loading-indicators";

export default function ComponentLoading() {
	return (
		<div className="w-full h-full flex justify-center items-center">
			<Riple color={["#0589ba", "#07aeeb", "#2cc2f9", "#5ed0fa"]} />
		</div>
	);
}
